module.exports = __webpack_public_path__ + "static/media/Logo - Teste.c82da112.png";